import { CalendarCloudSettings } from '../store/schema/CalendarCloudSettings';
import { getCalendarCloudSettingsStore } from '../store/store';

/**
 * Replaces unchanged values with null
 * @param settings Input calendar cloud settings
 */
export const filterUnchangedCalendarCloudSettings = (
    settings: CalendarCloudSettings
): CalendarCloudSettings => {
    const storeSettings = getCalendarCloudSettingsStore();
    const filteredSettings: CalendarCloudSettings = {};

    Object.keys(settings).map(key => {
        filteredSettings[key] = settings[key] !== storeSettings[key] ? settings[key] : null;
    });

    return filteredSettings;
};
